import { FoldersTable } from '@/modules/my-docs/components/FoldersTable.jsx';

export const Files = () => {
  return <FoldersTable />;
};
